var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.optionalClass},[_c('svg',{staticClass:"load"},[_c('circle',{attrs:{"cx":"50%","cy":"50%","r":"42.5%","stroke-width":"7.5%","fill":"none"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }